class MapLocationFormController {
  constructor() {
    this.name = 'mapLocationForm';
  }
}

export default MapLocationFormController;
